// src/services/PlanService.js
import APIService from "../modules/apiService";
import Helpers from "../modules/helpers";
import locales_es from "../locales/es";
import { PLAN_TAGS, MODAL_STATE, MODAL_TYPE, STANDARD_MODAL_TYPE } from "../models/constants";

const api = new APIService();
const helpers = new Helpers();

/**
 * Convierte un planTag en un objeto con `tag` y `name` legible
 */
export function buildPlanFromTag(planTag) {
	const tagToName = {
		[PLAN_TAGS.FREE]: "GRATUITO",
		[PLAN_TAGS.PRO]: "PRO",
		[PLAN_TAGS.ENTERPRISE]: "ENTERPRISE"
	};
	
	return {
		tag: planTag,
		name: tagToName[planTag] || planTag.toUpperCase()
	};
}

/**
 * Muestra un modal de confirmación básica para suscribirse al plan
 */
export function subscribeToPlanWithModal(planTag, showMainModal, dispatch) {
	if (!showMainModal || !dispatch) return;
	
	const plan = buildPlanFromTag(planTag);
	
	showMainModal(
		`¿Suscribirse al plan ${plan.name}?`,
		'Te llevaremos a la pasarela de suscripción para que puedas activar tu plan',
		null,
		[
			{
				label: locales_es.confirm,
				class: 'btn btn-success btn-elevate btn-pill btn-elevate-air',
				method: () => {
					subscribeToPlan(plan, dispatch, showMainModal);
				}
			},
			{
				label: locales_es.cancel,
				class: 'btn btn-danger btn-elevate btn-pill btn-elevate-air',
			}
		]
	);
}

/**
 * Muestra un modal con input de email para suscribirse a planes pagos
 */
export function subscribeToPlan(plan, dispatch, showMainModal) {
	const modalId = 'modal-subscribe-email';
	
	dispatch({
		type: MODAL_STATE.OPEN,
		modalName: modalId,
		modalType: MODAL_TYPE.STANDARD,
		payload: {
			modalId,
			title: `Suscribirse al plan ${plan.name}`,
			width: 'md',
			height: 'auto',
			heightBody: 'auto',
			children: (
				<div className="form-group">
					<p>
            <span className="kt-font-bolder kt-font-info">
              Necesitamos que nos digas el e-mail de tu cuenta de Mercado Pago para que podamos suscribirte correctamente. Luego, te llevaremos a la pasarela de suscripción para que puedas activar tu plan.
            </span>
					</p>
					<label>Email de contacto <span className="text-danger">*</span></label>
					<input type="email" className="form-control" id="subscription-email" placeholder="Ingresá tu email" required />
				</div>
			),
			actions: [
				{
					title: locales_es.cancel,
					type: STANDARD_MODAL_TYPE.CANCEL,
					className: 'btn btn-danger',
					closeOnClick: true,
				},
				{
					title: locales_es.confirm,
					type: STANDARD_MODAL_TYPE.CONFIRM,
					className: 'btn btn-success',
					closeOnClick: true,
					onClick: async () => {
						const email = document.getElementById('subscription-email').value;
						if (!email || !email.includes('@')) {
							showMainModal?.(locales_es.infoModal.title, 'Por favor ingresá un email válido');
							return;
						}
						await confirmSubscription(plan.tag, email, showMainModal);
					}
				}
			]
		}
	});
}

/**
 * Llama a la API para iniciar la suscripción
 */
export async function confirmSubscription(planTag, email, showMainModal) {
	try {
		const res = await api.postPlanSubscribe(planTag, email);
		if (res.data?.init_point) {
			window.open(res.data.init_point, '_self');
		} else {
			showMainModal?.(locales_es.successModal.title, res.message ?? locales_es.successModal.message);
		}
	} catch (err) {
		showMainModal?.(locales_es.errorModal.title, helpers.getErrorMsg(err));
	}
}
